import { useHistory } from "../contexts/History";

export const isExternalVisit = () => {
    const { history } = useHistory();
    return history.length <= 1;
}
